export default "__VITE_ASSET__Bwb$Z6IC__"